import React, {
  useEffect
} from 'react'
import PropTypes from 'prop-types'
import {
  connect
} from 'react-redux'

import {
  pipe
} from '../../../domain/helpers'

import {
  CategoryWrapper,
  H1
} from './styles'

import {
  Product
} from '../'

function VerticalMenuComponent(props) {
  const {
    storeLogo,
    handleViewProduct,
    cart,
    categories,
    storeImg
  } = props

  useEffect(() => {
    const products = []

    if (categories) {
      categories.forEach(function (item) {
        products.push(item.products)
      })
    }

    return () => { }
  }, [
    categories
  ])

  return <>
    {categories && categories.length && categories.map((mappedItem, index) => {
      const {
        products,
        name: categoryName,
        id: categoryId
      } = mappedItem

      const key = `stores-products-category-${index}`

      return <CategoryWrapper name={mappedItem.name} className={`store-category-products`} id={`store-category-products-${mappedItem.name}`} key={key}>
        <H1>{mappedItem.name}</H1>

        {products && products.map((mappedItem, index) => {
          const {
            id,
            name,
            description,
            image,
            value,
            additionals,
            promotionalValue
          } = mappedItem

          const key = `stores-products-category-group-${index}`
          const formattedPrice = `R$ ${Number(value).toFixed(2).replace('.', ',')}`
          const formattedPricePromotional = promotionalValue ? `R$ ${Number(promotionalValue).toFixed(2).replace('.', ',')}` : null
          const cartProductPrevious = cart && (cart.products && cart.products.length) ? (cart.products.filter(filteredItem => filteredItem.id === id))[0] : null
          const selectedAdditionals = (cartProductPrevious && cartProductPrevious.selectedAdditionals) || []

          return <Product
            direction={'vertical'}
            key={key}
            selectedCategory={{
              name: categoryName,
              id: categoryId
            }}
            handleView={handleViewProduct}
            id={id}
            name={name}
            description={description}
            image={image}
            storeLogo={storeLogo}
            value={formattedPrice}
            rawPrice={value}
            rawPromocional={promotionalValue}
            additionals={additionals}
            selectedAdditionals={selectedAdditionals}
            promotionalValue={formattedPricePromotional}
            storeImg={storeImg}
          />
        })}
      </CategoryWrapper>
    })
    }</>
}

VerticalMenuComponent.propTypes = {
	storeImg: PropTypes.string,
  storeLogo: PropTypes.string,
  selectedProduct: PropTypes.object,
  handleViewProduct: PropTypes.func,
  cart: PropTypes.shape({
		products: PropTypes.arrayOf(PropTypes.shape({}))
	}),
  categories: PropTypes.arrayOf(PropTypes.shape({}))
}

const mapStateToProps = (state) => {
  return {
    cart: state.main.cart || {},
    categories: state.main.categories || []
  }
}

const GetConnection = connect(mapStateToProps, {})

export const VerticalMenu = React.memo(pipe(
  GetConnection
)(VerticalMenuComponent))
